// removed by extract-text-webpack-plugin
module.exports = {"avatar":"_3TmQW","xxsmall":"_3U2jb","xsmall":"_2A9cy","small":"_25Dca","medium":"_2iwjn","large":"jbvvS","xlarge":"zvyIg","share-prompt-profile":"aeMH5","share-prompt-profile-mobile":"_2orok"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Avatar/Avatar.scss
// module id = ./src/components/Avatar/Avatar.scss
// module chunks = 4